import {
  NineActions,
  NineButton,
  NineHeading
} from "@9amhealth/wcl/generated/react";
import { FC } from "react";
import { TranslationKey } from "src/types/translationKey";
import Translate from "src/ui/components/Translate/Translate";
import { InfoText, StepContent } from "../components";

export interface FinalScreenProps {
  titleKey: TranslationKey;
  descriptionKey: TranslationKey;
  buttonKey: TranslationKey;
  buttonAction: () => void;
  icon?: React.ReactNode;
}

export const FinalScreen: FC<FinalScreenProps> = ({
  titleKey,
  descriptionKey,
  buttonKey,
  buttonAction,
  icon
}) => {
  return (
    <StepContent>
      <NineHeading>
        {icon}
        <h3 className="as-h4-large">
          <Translate msg={titleKey} />
        </h3>
      </NineHeading>
      <InfoText>
        <Translate msg={descriptionKey} />
      </InfoText>
      <NineActions style={{ justifyContent: "center" }}>
        <NineButton onClick={buttonAction}>
          <Translate msg={buttonKey} />
        </NineButton>
      </NineActions>
    </StepContent>
  );
};
